export default __webpack_public_path__ + "static/media/icon-play.0990b954.svg";